export default "__VITE_ASSET__$T8uf6Dq__"